class gestoresService {//servicios para login
    axios
    baseUrl

    constructor(axios, baseUrl) {
        this.axios = axios;
        this.baseUrl = `${baseUrl}`;
    }

    listUserTypes() {
        return this.axios.get(`${this.baseUrl}/tipo_usuario`)
    }

    completeAddress(body) {
        const url = `${this.baseUrl}/actualizar_direccion`
        return this.axios.put(url.toString(), body);
    }

    catTipoSuscripcionGestor() {
        return this.axios.get(`${this.baseUrl}/cat_tipo_suscripcion_gestor`);
    }

    catTipoSuscripcionGestorCreate(body) {
        return this.axios.post(`${this.baseUrl}/cat_tipo_suscripcion_gestor`, body);
    }

    catTipoSuscripcionGestorUpdate(body) {
        return this.axios.put(`${this.baseUrl}/cat_tipo_suscripcion_gestor`, body);
    }

    catTipoSuscripcionGestorDelete(body) {
        return this.axios.delete(`${this.baseUrl}/cat_tipo_suscripcion_gestor`, 
        {
            data: body
        });
    }

    asginarSuscripcion(body) {
        return this.axios.post(`${this.baseUrl}/asignar_suscripcion`, body);
    }

    completarSuscripcion(body) {
        return this.axios.post(`${this.baseUrl}/completar_suscripcion`, body);
    }

    enviarCorreoSuscripcion(body) {
        return this.axios.post(`${this.baseUrl}/enviar_correo_suscripcion`, body);
    }

    validarNitDpi(body) {
        return this.axios.post(`${this.baseUrl}/validar_nit_dpi`, body);
    }

    agregarClientesSuscripcion(body) {
        return this.axios.post(`${this.baseUrl}/agregar_clientes_suscripcion`, body);
    }

    enviarCorreoAdicionClientes(){
        return this.axios.get(`${this.baseUrl}/enviar_correo_adicion_clientes`);
    }

    listadoUsuarios() {
        return this.axios.get(`${this.baseUrl}/listado_usuarios`);
    }

    modificarInformacionUsuario(body) {
        return this.axios.put(`${this.baseUrl}/modificar_informacion_usuario`, body);
    }

    seguimientoPresentacionGestor(body) {
        return this.axios.get(`${this.baseUrl}/seguimiento_presentacion_gestor`, {
            params: body
        });
    }    

    actualizarInfoClienteGestor(body) {
        return this.axios.put(`${this.baseUrl}/actualizar_datos_sat`, body);
    }
}

export default gestoresService;